import { UserLanguageCode } from '@/app/store/api/restApi';

export const normalizeLanguageCode = (lang: string | undefined): UserLanguageCode | undefined => {
  const base = lang?.toLowerCase().split('-')[0];
  if (base === 'ru') return UserLanguageCode.Ru;
  if (base === 'en') return UserLanguageCode.En;
  if (base === 'ar') return UserLanguageCode.Ar;
  return undefined;
};
